import React, { useState, useEffect } from 'react'
import {
  Box,
  TextField,
  makeStyles,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  signatureRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
}))

const BlurField = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value || '')
  useEffect(() => { setLocal(value || '') }, [value])
  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value || '')) onCommit(local) }}
    />
  )
}

const IntroEditor = ({ data, onChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <BlurField
        label="Greeting"
        value={data.greeting || ''}
        onCommit={(v) => onChange('greeting', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <BlurField
        label="Body"
        value={data.body || ''}
        onCommit={(v) => onChange('body', v)}
        size="small"
        variant="outlined"
        fullWidth
        multiline
        rows={6}
      />

      <BlurField
        label="Closing"
        value={data.closing || ''}
        onCommit={(v) => onChange('closing', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <Box className={classes.signatureRow}>
        <BlurField
          label="Signature Name"
          value={data.signatureName || ''}
          onCommit={(v) => onChange('signatureName', v)}
          size="small"
          variant="outlined"
          fullWidth
        />
        <BlurField
          label="Signature Title"
          value={data.signatureTitle || ''}
          onCommit={(v) => onChange('signatureTitle', v)}
          size="small"
          variant="outlined"
          fullWidth
        />
      </Box>
    </Box>
  )
}

export default IntroEditor
